import React from 'react';
import { Field } from 'redux-form';
import { required } from '../../../utils/validate';
import { formatAmount, toNumber } from '../../../utils/formatters';
import OptionList from "../../Forms/OptionList/optionList";
import Input from '../../Forms/Input/input';
import Select from '../../Forms/Select/select';

const residentStatuses = [
  {
    "value": "RENT",
    "text": "Rent"
  },
  {
    "value": "OWN",
    "text": "Own"
  },
  {
    "value": "OTHER",
    "text": "Other"
  }
];

const HousingFieldSet = () => {
  return (
    <fieldset className="container">
      <legend className="row">Housing</legend>

      <div className="row">

        <div className="col-12 col-lg-6">
          <Field
            name="residentStatus"
            label="Resident status"
            component={Select}
            type="select"
            defaultValue=""
            validate={[required]}
            required={true}
          >
            <OptionList options={residentStatuses} />
          </Field>
        </div>

        <div className="col-12 col-lg-6">
          <Field
            name="yearsAtResidence"
            label="Years at residence"
            component={Input}
            type="text"
            normalize={toNumber}
            validate={[required]}
            required={true}
            htmlAttributes={{ maxLength: "2" }}
          />
        </div>

      </div>

      <div className="row">

        <div className="col-12 col-lg-6">
          <Field
            name="monthlyHousingPayment"
            label="Monthly housing payment"
            component={Input}
            type="text"
            format={formatAmount}
            normalize={toNumber}
            validate={[required]}
            required={true}
            htmlAttributes={{ maxLength: "7" }}
            smallDisclosure={{
              text: "The amount you spend each month on rent and mortgage."
            }}
            postfix=".00"
          />
        </div>

      </div>
    </fieldset>);
};

export default HousingFieldSet;

